(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery-estimator"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__PDP_DELIVERY_ESTIMATOR__) return;
    window.__PDP_DELIVERY_ESTIMATOR__ = true;
    const DEFAULT_FULFILLMENT_MODE = 'shipping';

    function normalizeFulfillmentMode(mode) {
      return mode === 'pickup' ? 'pickup' : DEFAULT_FULFILLMENT_MODE;
    }

    function getPreferredFulfillmentMode() {
      return normalizeFulfillmentMode(window.__PDP_PREFERRED_FULFILLMENT_MODE__);
    }

    function setPreferredFulfillmentMode(mode) {
      window.__PDP_PREFERRED_FULFILLMENT_MODE__ = normalizeFulfillmentMode(mode);
    }

    function getRoot() {
      return document.querySelector('[data-delivery-estimator]');
    }

    function getEls() {
      const root = getRoot();
      if (!root) return null;

      return {
        root: root,
        zip: root.querySelector('[data-delivery-estimator-zip]'),
        submit: root.querySelector('[data-delivery-estimator-submit]'),
        toggle: root.querySelector('[data-delivery-estimator-toggle]'),
        form: root.querySelector('[data-delivery-estimator-form]'),
        zipSummary: root.querySelector('[data-delivery-estimator-zip-summary]'),
        status: root.querySelector('[data-delivery-estimator-status]'),
        standardEstimate: root.querySelector('[data-delivery-standard-estimate]'),
        standardPrice: root.querySelector('[data-delivery-standard-price]'),
        expeditedEstimate: root.querySelector('[data-delivery-expedited-estimate]'),
        expeditedPrice: root.querySelector('[data-delivery-expedited-price]')
      };
    }

    function getFulfillmentRoot() {
      return document.querySelector('[data-product-fulfillment]');
    }

    function getFulfillmentEls() {
      const root = getFulfillmentRoot();
      if (!root) return null;

      return {
        root: root,
        shippingToggle: root.querySelector('[data-fulfillment-toggle="shipping"]'),
        pickupToggle: root.querySelector('[data-fulfillment-toggle="pickup"]'),
        shippingPanel: root.querySelector('[data-fulfillment-panel="shipping"]'),
        pickupPanel: root.querySelector('[data-fulfillment-panel="pickup"]'),
        shippingSummary: root.querySelector('[data-fulfillment-summary="shipping"]'),
        pickupSummary: root.querySelector('[data-fulfillment-summary="pickup"]')
      };
    }

    function getCurrentVariantState() {
      const form = document.querySelector('[data-product-form]');
      if (!form) return null;

      let product = null;
      try {
        product = JSON.parse(form.getAttribute('data-product') || '{}');
      } catch (error) {
        product = null;
      }

      const variants = Array.isArray(product && product.variants) ? product.variants : [];
      const master = form.querySelector('select[name="id"], select[data-variants]');
      let variantId = master && master.value ? String(master.value) : '';
      if (!variantId) {
        try {
          variantId = new URL(window.location.href).searchParams.get('variant') || '';
        } catch (error) {
          variantId = '';
        }
      }

      const variant = variants.find(function(item) {
        return String(item.id) === String(variantId);
      }) || null;

      const fallbackVariant = variant || variants[0] || null;

      return {
        variantId: fallbackVariant && fallbackVariant.id ? String(fallbackVariant.id) : '',
        available: !!(fallbackVariant && fallbackVariant.available)
      };
    }

    function getStorageKey() {
      const root = getRoot();
      return root ? root.getAttribute('data-storage-key') || 'pdp_delivery_zip' : 'pdp_delivery_zip';
    }

    function readStoredZip() {
      try {
        return window.localStorage.getItem(getStorageKey()) || '';
      } catch (error) {
        return '';
      }
    }

    function writeStoredZip(value) {
      try {
        if (value) {
          window.localStorage.setItem(getStorageKey(), value);
        } else {
          window.localStorage.removeItem(getStorageKey());
        }
      } catch (error) {}
    }

    function setStatus(message, muted) {
      const els = getEls();
      if (!els || !els.status) return;
      els.status.textContent = message || '';
      els.status.hidden = !message;
      els.status.classList.toggle('is-muted', !!message && !!muted);
    }

    function setLoading(isLoading) {
      const els = getEls();
      if (!els || !els.submit) return;
      els.submit.disabled = !!isLoading;
      els.submit.classList.remove('is-success');
      const defaultLabel = els.submit.getAttribute('data-submit-label') || 'Update estimate';
      els.submit.textContent = isLoading
        ? '...'
        : defaultLabel;
    }

    function setSubmitSuccess() {
      const els = getEls();
      if (!els || !els.submit) return;
      els.submit.disabled = false;
      els.submit.classList.add('is-success');
      els.submit.textContent = '✓';

      window.setTimeout(function() {
        const currentEls = getEls();
        if (!currentEls || !currentEls.submit || currentEls.submit.disabled) return;
        currentEls.submit.classList.remove('is-success');
        currentEls.submit.textContent = currentEls.submit.getAttribute('data-submit-label') || 'Update estimate';
      }, 1400);
    }

    function updateZipSummary(zipValue) {
      const els = getEls();
      if (!els || !els.zipSummary || !els.toggle) return;

      const hasZip = !!zipValue;
      if (hasZip) {
        els.zipSummary.textContent = (els.root.getAttribute('data-zip-prefix') || 'ZIP code') + ': ' + zipValue;
        els.toggle.textContent = els.toggle.getAttribute('data-edit-label') || 'Edit ZIP code';
      } else {
        els.zipSummary.textContent = els.root.getAttribute('data-no-zip-label') || 'Enter ZIP code for a more accurate estimate';
        els.toggle.textContent = els.toggle.getAttribute('data-enter-label') || 'Enter ZIP code';
      }
    }

    function updateZipSummaryWithMode(zipValue) {
      const els = getEls();
      if (!els || !els.zipSummary || !els.toggle) return;

      if (!zipValue) {
        updateZipSummary('');
        return;
      }

      els.zipSummary.textContent = (els.root.getAttribute('data-zip-prefix') || 'ZIP code') + ': ' + zipValue;
      els.toggle.textContent = els.toggle.getAttribute('data-edit-label') || 'Edit ZIP code';
    }

    function setEditorOpen(isOpen) {
      const els = getEls();
      if (!els || !els.form) return;
      els.form.hidden = !isOpen;
      if (isOpen && els.zip) {
        window.setTimeout(function() {
          els.zip.focus();
          els.zip.select();
        }, 0);
      }
    }

    function getPreferredZip() {
      const root = getRoot();
      if (!root) return '';
      const storedZip = readStoredZip();
      if (storedZip) return storedZip;
      return root.getAttribute('data-customer-zip') || '';
    }

    function setVisibility() {
      const els = getEls();
      if (!els) return;
      els.root.hidden = false;
    }

    function updateShippingCardSummary(text) {
      const fulfillment = getFulfillmentEls();
      if (!fulfillment || !fulfillment.shippingSummary) return;
      fulfillment.shippingSummary.textContent = text || 'Estimate by ZIP code';
    }

    function updatePickupCardSummary() {
      const fulfillment = getFulfillmentEls();
      if (!fulfillment || !fulfillment.pickupSummary || !fulfillment.pickupPanel) return;

      const items = fulfillment.pickupPanel.querySelectorAll('[data-surface-pick-up-inline-item]');
      if (!items.length) {
        fulfillment.pickupSummary.textContent = 'Store availability';
        return;
      }

      const availableItems = Array.from(items).filter(function(item) {
        return item.getAttribute('data-location-available') === 'true';
      });
      const firstAvailable = availableItems[0];
      const pickupTime = firstAvailable ? (firstAvailable.getAttribute('data-pickup-time') || '').trim() : '';

      if (pickupTime) {
        fulfillment.pickupSummary.textContent = pickupTime;
      } else if (availableItems.length > 0) {
        fulfillment.pickupSummary.textContent = availableItems.length + ' store pickup option' + (availableItems.length === 1 ? '' : 's');
      } else {
        fulfillment.pickupSummary.textContent = 'Store availability';
      }
    }

    function setActiveFulfillment(mode) {
      const fulfillment = getFulfillmentEls();
      if (!fulfillment) return;

      const normalizedMode = normalizeFulfillmentMode(mode);
      const isShipping = normalizedMode !== 'pickup';
      if (fulfillment.shippingToggle) {
        fulfillment.shippingToggle.classList.toggle('is-active', isShipping);
        fulfillment.shippingToggle.setAttribute('aria-pressed', isShipping ? 'true' : 'false');
      }
      if (fulfillment.pickupToggle) {
        fulfillment.pickupToggle.classList.toggle('is-active', !isShipping);
        fulfillment.pickupToggle.setAttribute('aria-pressed', !isShipping ? 'true' : 'false');
      }
      if (fulfillment.shippingPanel) {
        fulfillment.shippingPanel.hidden = !isShipping;
        fulfillment.shippingPanel.classList.toggle('is-active', isShipping);
      }
      if (fulfillment.pickupPanel) {
        fulfillment.pickupPanel.hidden = isShipping;
        fulfillment.pickupPanel.classList.toggle('is-active', !isShipping);
      }

      setPreferredFulfillmentMode(normalizedMode);
    }

    function syncFulfillmentVisibility() {
      const fulfillment = getFulfillmentEls();
      const estimator = getEls();
      if (!fulfillment) return;

      const shippingVisible = !!(estimator && !estimator.root.hidden);

      if (fulfillment.root) {
        fulfillment.root.hidden = !shippingVisible;
      }

      if (fulfillment.shippingToggle) {
        fulfillment.shippingToggle.hidden = !shippingVisible;
      }

      if (fulfillment.pickupToggle) {
        fulfillment.pickupToggle.hidden = !shippingVisible;
      }

      const preferredMode = getPreferredFulfillmentMode();

      if (shippingVisible) {
        setActiveFulfillment(preferredMode === 'pickup' ? 'pickup' : 'shipping');
      }
    }

    function deriveShippingSummaryText(estimateText) {
      const rawText = String(estimateText || '').trim();
      if (!rawText) return 'Estimate by ZIP code';
      return rawText.replace(/^Estimated delivery date:\s*/i, 'Arrives ');
    }

    function applyEstimate(data) {
      const els = getEls();
      if (!els || !data) return;

      if (els.standardEstimate) {
        els.standardEstimate.textContent = data.standard && data.standard.estimate_text ? data.standard.estimate_text : '';
      }

      if (els.standardPrice) {
        els.standardPrice.textContent = data.standard && data.standard.price_text ? data.standard.price_text : '';
      }

      if (els.expeditedEstimate) {
        els.expeditedEstimate.textContent = data.expedited && data.expedited.estimate_text ? data.expedited.estimate_text : '';
      }

      if (els.expeditedPrice) {
        els.expeditedPrice.textContent = data.expedited && data.expedited.price_text ? data.expedited.price_text : '';
      }

      updateShippingCardSummary(deriveShippingSummaryText(data.standard && data.standard.estimate_text));
    }

    function normalizeZipForRequest(value) {
      const rawValue = String(value || '').trim();
      if (!rawValue) return '';
      const digits = rawValue.replace(/\D/g, '');
      if (digits.length >= 5) return digits.slice(0, 5);
      return rawValue;
    }

    async function fetchEstimate(useZip) {
      const els = getEls();
      const state = getCurrentVariantState();
      if (!els || !state || !state.variantId) return false;

      const params = new URLSearchParams();
      params.set('variant_id', state.variantId);

      const zip = normalizeZipForRequest(els.zip && els.zip.value);
      if (useZip && zip) {
        params.set('zip', zip);
      }

      setLoading(true);
      setStatus('', false);

      try {
        const response = await fetch(els.root.getAttribute('data-endpoint') + '?' + params.toString(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json'
          }
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        if (!response.ok || !payload || payload.ok !== true) {
          throw new Error(payload && payload.error ? payload.error : '');
        }

        applyEstimate(payload);
        return true;
      } catch (error) {
        if (useZip && zip) {
          const message = error && error.message
            ? error.message
            : (els.root.getAttribute('data-generic-error-label') || '');
          setStatus(message, false);
        } else {
          setStatus('', false);
        }
        return false;
      } finally {
        setLoading(false);
      }
    }

    function refreshFromCurrentState() {
      setVisibility();
      syncFulfillmentVisibility();
      const els = getEls();
      const state = getCurrentVariantState();
      if (!els || !state || !state.variantId) return;

      const hasZip = !!normalizeZipForRequest(els.zip && els.zip.value);
      fetchEstimate(hasZip);
    }

    document.addEventListener('DOMContentLoaded', function() {
      const els = getEls();
      const fulfillment = getFulfillmentEls();
      if (els && els.zip) {
        const preferredZip = normalizeZipForRequest(getPreferredZip());
        if (preferredZip) {
          els.zip.value = preferredZip;
          updateZipSummaryWithMode(preferredZip);
        } else {
          updateZipSummary('');
        }
      }
      setVisibility();
      setPreferredFulfillmentMode(DEFAULT_FULFILLMENT_MODE);
      setActiveFulfillment(getPreferredFulfillmentMode());
      updateShippingCardSummary('Estimate by ZIP code');
      updatePickupCardSummary();
      syncFulfillmentVisibility();
      fetchEstimate(!!(els && els.zip && normalizeZipForRequest(els.zip.value)));

      if (fulfillment && fulfillment.pickupPanel) {
        const observer = new MutationObserver(function() {
          updatePickupCardSummary();
          syncFulfillmentVisibility();
        });
        observer.observe(fulfillment.pickupPanel, { childList: true, subtree: true });
      }
    });

    document.addEventListener('variant:change', refreshFromCurrentState);
    document.addEventListener('product:variant:change', refreshFromCurrentState);
    document.addEventListener('product:color-swap:done', refreshFromCurrentState);

    async function handleEstimateRequest() {
      const els = getEls();
      const zipValue = normalizeZipForRequest(els && els.zip && els.zip.value);
      if (!zipValue) {
        return fetchEstimate(false);
      }

      return fetchEstimate(true);
    }

    document.addEventListener('click', function(event) {
      const fulfillmentToggle = event.target.closest('[data-fulfillment-toggle]');
      if (fulfillmentToggle) {
        event.preventDefault();
        event.stopPropagation();
        setActiveFulfillment(fulfillmentToggle.getAttribute('data-fulfillment-toggle') || 'shipping');
        return;
      }

      const toggle = event.target.closest('[data-delivery-estimator-toggle]');
      if (toggle) {
        event.preventDefault();
        event.stopPropagation();
        const els = getEls();
        if (!els || !els.form) return;
        setEditorOpen(els.form.hidden);
        return;
      }

      const button = event.target.closest('[data-delivery-estimator-submit]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      const els = getEls();
      const normalizedZip = normalizeZipForRequest(els && els.zip && els.zip.value);
      writeStoredZip(normalizedZip);
      if (els && els.zip) {
        els.zip.value = normalizedZip;
      }
      updateZipSummaryWithMode(normalizedZip);
      setEditorOpen(false);
      handleEstimateRequest().then(function(ok) {
        if (ok && normalizedZip) setSubmitSuccess();
      });
    });

    document.addEventListener('keydown', function(event) {
      const input = event.target.closest('[data-delivery-estimator-zip]');
      if (!input || event.key !== 'Enter') return;

      event.preventDefault();
      event.stopPropagation();
      const els = getEls();
      const normalizedZip = normalizeZipForRequest(els && els.zip && els.zip.value);
      writeStoredZip(normalizedZip);
      if (els && els.zip) {
        els.zip.value = normalizedZip;
      }
      updateZipSummaryWithMode(normalizedZip);
      setEditorOpen(false);
      handleEstimateRequest().then(function(ok) {
        if (ok && normalizedZip) setSubmitSuccess();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (function() {
    const namespace = window.DardanosProductGallery || {};
    const DESKTOP_QUERY = '(min-width: 799px)';

    if (namespace._rafInit) {
      window.cancelAnimationFrame(namespace._rafInit);
      namespace._rafInit = null;
    }

    function isDesktop() {
      if (window.PXUTheme && window.PXUTheme.media_queries && window.PXUTheme.media_queries.large) {
        return window.PXUTheme.media_queries.large.matches;
      }

      return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function getGalleryRoot(target) {
      if (!target) return null;
      if (target instanceof HTMLElement) return target;
      if (target.jquery) return target[0];
      return null;
    }

    function getItems(gallery) {
      return Array.from(gallery.querySelectorAll('.product-gallery__media-item'));
    }

    function getToggle(gallery) {
      return gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-desktop-gallery-toggle]') || null;
    }

    function getDotsWrap(gallery) {
      return gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-product-gallery-dots]') || null;
    }

    function getDotButtons(gallery) {
      const wrap = getDotsWrap(gallery);
      return wrap ? Array.from(wrap.querySelectorAll('[data-product-gallery-dot]')) : [];
    }

    function getPrevButton(gallery) {
      return gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-product-gallery-prev]') || null;
    }

    function getNextButton(gallery) {
      return gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-product-gallery-next]') || null;
    }

    function getWrap(target) {
      if (!target) return null;
      return target.closest('[data-product-gallery-wrap]');
    }

    function destroyLegacyGallery(gallery) {
      if (!gallery) return;

      const thumbnailGallery = gallery.closest('.js-product-section')?.querySelector('.product_gallery_nav');
      const galleryInstance = window.Flickity && window.Flickity.data ? window.Flickity.data(gallery) : undefined;
      const thumbnailGalleryInstance = thumbnailGallery && window.Flickity && window.Flickity.data
        ? window.Flickity.data(thumbnailGallery)
        : undefined;

      if (galleryInstance !== undefined && window.jQuery) {
        try {
          window.jQuery(gallery).flickity('destroy');
        } catch (_) {}
      }

      if (thumbnailGalleryInstance !== undefined && window.jQuery) {
        try {
          window.jQuery(thumbnailGallery).flickity('destroy');
        } catch (_) {}
      }

      gallery
        .querySelectorAll('.flickity-prev-next-button, .flickity-page-dots')
        .forEach(node => node.remove());

      gallery.classList.remove('flickity-enabled');

      if (thumbnailGallery) {
        thumbnailGallery
          .querySelectorAll('.flickity-prev-next-button, .flickity-page-dots')
          .forEach(node => node.remove());
        thumbnailGallery.classList.remove('flickity-enabled');
      }
    }

    function shouldUseDesktopGrid(gallery) {
      if (!gallery) return false;
      return gallery.dataset.desktopGridGallery === 'true' && isDesktop();
    }

    function shouldUseCustomGallery(gallery) {
      return !!gallery && gallery.dataset.desktopGridGallery === 'true';
    }

    function getActiveIndex(gallery) {
      if (!gallery) return 0;

      if (shouldUseDesktopGrid(gallery)) {
        const selected = gallery.querySelector('.product-gallery__media-item.is-selected');
        return selected ? parseInt(selected.dataset.mediaIndex || '0', 10) : 0;
      }

      const selected = gallery.querySelector('.product-gallery__media-item.is-selected');
      if (selected) {
        return parseInt(selected.dataset.mediaIndex || '0', 10);
      }

      const activeIndex = parseInt(gallery.dataset.activeIndex || '0', 10);
      return Number.isNaN(activeIndex) ? 0 : activeIndex;
    }

    function setActiveIndex(gallery, index) {
      if (!gallery) return;

      const items = getItems(gallery);
      const safeIndex = Math.max(0, Math.min(index, items.length - 1));
      const dots = getDotButtons(gallery);

      items.forEach((item, itemIndex) => {
        item.classList.toggle('is-selected', itemIndex === safeIndex);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === safeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const prevButton = getPrevButton(gallery);
      const nextButton = getNextButton(gallery);
      const isMobileSlider = !shouldUseDesktopGrid(gallery);

      if (prevButton) {
        prevButton.disabled = !isMobileSlider || safeIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = !isMobileSlider || safeIndex >= items.length - 1;
      }

      if (isMobileSlider) {
        items.forEach((item, itemIndex) => {
          item.style.display = itemIndex === safeIndex ? 'block' : 'none';
        });
      } else {
        items.forEach(item => {
          item.style.removeProperty('display');
        });
      }
    }

    function setMobileSliderPosition(gallery, index) {
      if (!gallery || shouldUseDesktopGrid(gallery)) return;

      const items = getItems(gallery);
      const safeIndex = Math.max(0, Math.min(index, items.length - 1));
      gallery.dataset.activeIndex = String(safeIndex);
      setActiveIndex(gallery, safeIndex);
    }

    function applyMobileInlineLayout(gallery) {
      if (!gallery || shouldUseDesktopGrid(gallery)) return;

      const wrap = gallery.closest('[data-product-gallery-wrap]');
      const nav = wrap ? wrap.querySelector('[data-product-gallery-mobile-nav]') : null;
      const dotsWrap = getDotsWrap(gallery);
      const expandButton = wrap ? wrap.querySelector('[data-product-gallery-expand]') : null;

      gallery.style.display = 'block';
      gallery.style.position = 'relative';
      gallery.style.overflow = 'visible';
      gallery.style.transform = 'none';
      gallery.style.touchAction = 'pan-y';

      if (wrap) {
        wrap.style.position = 'relative';
      }

      if (nav) {
        nav.style.display = 'block';
        nav.style.position = 'absolute';
        nav.style.inset = '0';
        nav.style.margin = '0';
        nav.style.pointerEvents = 'none';
        nav.style.zIndex = '4';
      }

      if (dotsWrap) {
        dotsWrap.style.display = 'flex';
        dotsWrap.style.position = 'absolute';
        dotsWrap.style.left = '50%';
        dotsWrap.style.right = 'auto';
        dotsWrap.style.bottom = '14px';
        dotsWrap.style.top = 'auto';
        dotsWrap.style.transform = 'translateX(-50%)';
        dotsWrap.style.zIndex = '5';
        dotsWrap.style.pointerEvents = 'auto';
        dotsWrap.style.background = 'rgba(255,255,255,.96)';
        dotsWrap.style.borderRadius = '999px';
        dotsWrap.style.padding = '8px 12px';
      }

      if (expandButton) {
        expandButton.style.display = 'flex';
        expandButton.style.pointerEvents = 'auto';
        expandButton.style.zIndex = '5';
      }

      gallery.querySelectorAll('.lightbox').forEach(link => {
        link.style.pointerEvents = 'none';
        link.style.touchAction = 'pan-y';
      });

      gallery.querySelectorAll('.image__container, .product-gallery__image').forEach(node => {
        node.style.touchAction = 'pan-y';
      });
    }

    function clearMobileInlineLayout(gallery) {
      if (!gallery) return;

      const wrap = gallery.closest('[data-product-gallery-wrap]');
      const nav = wrap ? wrap.querySelector('[data-product-gallery-mobile-nav]') : null;
      const dotsWrap = getDotsWrap(gallery);
      const expandButton = wrap ? wrap.querySelector('[data-product-gallery-expand]') : null;

      [
        ['display', gallery],
        ['position', gallery],
        ['overflow', gallery],
        ['transform', gallery],
        ['touch-action', gallery]
      ].forEach(([prop, el]) => el && el.style.removeProperty(prop));

      if (wrap) {
        wrap.style.removeProperty('position');
      }

      [nav, dotsWrap, expandButton].forEach(el => {
        if (!el) return;
        el.removeAttribute('style');
      });

      gallery.querySelectorAll('.lightbox, .image__container, .product-gallery__image').forEach(node => {
        node.style.removeProperty('pointer-events');
        node.style.removeProperty('touch-action');
      });
    }

    function syncGallery(gallery) {
      if (!gallery) return;

      const items = getItems(gallery);
      const toggle = getToggle(gallery);
      const dotsWrap = getDotsWrap(gallery);
      const limit = parseInt(gallery.dataset.desktopGridLimit || '4', 10);
      const expanded = gallery.dataset.desktopGridExpanded === 'true';
      const useGrid = shouldUseDesktopGrid(gallery);

      items.forEach((item, index) => {
        const isOverflow = index >= limit;
        item.classList.toggle('product-gallery__media-item--hidden', useGrid && isOverflow && !expanded);
      });

      if (dotsWrap) {
        dotsWrap.hidden = useGrid || items.length <= 1;
      }

      if (useGrid) {
        clearMobileInlineLayout(gallery);
        setActiveIndex(gallery, getActiveIndex(gallery));
      } else {
        applyMobileInlineLayout(gallery);
        setMobileSliderPosition(gallery, getActiveIndex(gallery));
      }

      if (!toggle) return;

      toggle.hidden = !useGrid || items.length <= limit;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded
        ? (toggle.dataset.labelLess || 'Show Less')
        : (toggle.dataset.labelMore || 'Show More Images');
    }

    function expandGallery(gallery, options) {
      if (!gallery) return;

      gallery.dataset.desktopGridExpanded = 'true';
      syncGallery(gallery);

      const mediaId = options && options.mediaId ? String(options.mediaId) : null;
      if (!mediaId) return;

      const target = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function collapseGallery(gallery) {
      if (!gallery) return;

      gallery.dataset.desktopGridExpanded = 'false';
      syncGallery(gallery);

      const wrap = gallery.closest('[data-product-gallery-wrap]');
      const scrollTarget = wrap || gallery;

      if (scrollTarget) {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function revealMediaIfNeeded(gallery, mediaId) {
      if (!gallery || !mediaId) return;

      const target = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target) return;

      const limit = parseInt(gallery.dataset.desktopGridLimit || '4', 10);
      const targetIndex = parseInt(target.dataset.mediaIndex || '-1', 10);
      const expanded = gallery.dataset.desktopGridExpanded === 'true';

      if (!expanded && targetIndex >= limit) {
        expandGallery(gallery, { mediaId: mediaId });
        return;
      }

      syncGallery(gallery);
    }

    function scrollToIndex(gallery, index) {
      setMobileSliderPosition(gallery, index);
    }

    function triggerMobileLightbox(control) {
      const wrap = getWrap(control);
      const gallery = wrap ? wrap.querySelector('.product_gallery[data-product-gallery]') : null;
      if (!gallery) return false;

      const activeItem = gallery.querySelector('.product-gallery__media-item.is-selected');
      const activeLightbox = activeItem ? activeItem.querySelector('.lightbox') : null;

      if (activeLightbox) {
        activeLightbox.click();
      }

      return false;
    }

    function inlineStep(control, delta) {
      const wrap = getWrap(control);
      const gallery = wrap ? wrap.querySelector('.product_gallery[data-product-gallery]') : null;
      if (!gallery) return false;

      scrollToIndex(gallery, getActiveIndex(gallery) + delta);
      return false;
    }

    function inlineGoTo(control, index) {
      const wrap = getWrap(control);
      const gallery = wrap ? wrap.querySelector('.product_gallery[data-product-gallery]') : null;
      if (!gallery) return false;

      scrollToIndex(gallery, index);
      return false;
    }

    function handleSwipeEnd(gallery, startX, startY, endX, endY) {
      if (!gallery || shouldUseDesktopGrid(gallery)) return;

      const deltaX = endX - startX;
      const deltaY = endY - startY;

      if (Math.abs(deltaX) < 36 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

      if (deltaX < 0) {
        scrollToIndex(gallery, getActiveIndex(gallery) + 1);
      } else {
        scrollToIndex(gallery, getActiveIndex(gallery) - 1);
      }
    }

    function bindMobileSwipe(gallery) {
      if (!gallery || gallery.dataset.mobileSwipeBound === 'true') return;

      let touchStartX = 0;
      let touchStartY = 0;
      let trackingTouch = false;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let trackingPointer = false;
      let lastSwipeAt = 0;

      function canHandleSwipe() {
        const now = Date.now();
        if (now - lastSwipeAt < 350) return false;
        lastSwipeAt = now;
        return true;
      }

      gallery.addEventListener('touchstart', function(event) {
        if (shouldUseDesktopGrid(gallery)) return;
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        trackingTouch = true;
      }, { passive: true });

      gallery.addEventListener('touchend', function(event) {
        if (!trackingTouch || shouldUseDesktopGrid(gallery)) return;

        const touch = event.changedTouches && event.changedTouches[0];
        trackingTouch = false;
        if (!touch) return;

        if (!canHandleSwipe()) return;
        handleSwipeEnd(gallery, touchStartX, touchStartY, touch.clientX, touch.clientY);
      }, { passive: true });

      gallery.addEventListener('pointerdown', function(event) {
        if (shouldUseDesktopGrid(gallery)) return;
        if (event.pointerType !== 'touch') return;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        trackingPointer = true;
      }, { passive: true });

      gallery.addEventListener('pointerup', function(event) {
        if (!trackingPointer || shouldUseDesktopGrid(gallery)) return;
        if (event.pointerType !== 'touch') return;
        trackingPointer = false;
        if (!canHandleSwipe()) return;
        handleSwipeEnd(gallery, pointerStartX, pointerStartY, event.clientX, event.clientY);
      }, { passive: true });

      gallery.addEventListener('pointercancel', function() {
        trackingPointer = false;
      }, { passive: true });

      gallery.dataset.mobileSwipeBound = 'true';
    }

    function focusMedia(mediaId, galleryTarget) {
      if (!mediaId) return;

      const gallery = getGalleryRoot(galleryTarget)
        || document.querySelector('.product_gallery[data-desktop-grid-gallery="true"]');

      if (!shouldUseCustomGallery(gallery)) return;

      const target = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target) return;

      if (!shouldUseDesktopGrid(gallery)) {
        const targetIndex = parseInt(target.dataset.mediaIndex || '0', 10);
        scrollToIndex(gallery, targetIndex);
        return;
      }

      revealMediaIfNeeded(gallery, mediaId);
      setActiveIndex(gallery, parseInt(target.dataset.mediaIndex || '0', 10));
    }

    function bindGallery(gallery) {
      if (!gallery || gallery.dataset.desktopGridBound === 'true') {
        syncGallery(gallery);
        return;
      }

      const toggle = getToggle(gallery);
      if (toggle) {
        toggle.addEventListener('click', function() {
          const expanded = gallery.dataset.desktopGridExpanded === 'true';

          if (expanded) {
            collapseGallery(gallery);
            return;
          }

          expandGallery(gallery);
        });
      }

      getDotButtons(gallery).forEach(dot => {
      });

      const expandButton = gallery.closest('[data-product-gallery-wrap]')?.querySelector('[data-product-gallery-expand]');
      if (expandButton) {
        expandButton.addEventListener('click', function() {
          triggerMobileLightbox(expandButton);
        });
      }

      bindMobileSwipe(gallery);
      gallery.dataset.desktopGridBound = 'true';
      syncGallery(gallery);
    }

    function initGallery(gallery) {
      if (!shouldUseCustomGallery(gallery)) return;
      bindGallery(gallery);
      destroyLegacyGallery(gallery);
      syncGallery(gallery);
    }

    function init() {
      document
        .querySelectorAll('.product_gallery[data-desktop-grid-gallery="true"]')
        .forEach(gallery => {
          initGallery(gallery);
        });
    }

    function scheduleInit() {
      if (namespace._rafInit) return;

      namespace._rafInit = window.requestAnimationFrame(function() {
        namespace._rafInit = null;
        init();
      });
    }

    namespace.initGallery = initGallery;
    namespace.init = init;
    namespace.scheduleInit = scheduleInit;
    namespace.syncGallery = syncGallery;
    namespace.focusMedia = focusMedia;
    namespace.isDesktopGrid = shouldUseDesktopGrid;
    namespace.isCustomGallery = shouldUseCustomGallery;
    namespace.inlineGoTo = inlineGoTo;
    window.DardanosProductGallery = namespace;

    if (!namespace._eventsBound) {
      namespace._onReady = function() {
        scheduleInit();
      };

      namespace._onResize = function() {
        scheduleInit();
      };

      namespace._onSwap = function() {
        scheduleInit();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', namespace._onReady, { once: true });
      } else {
        scheduleInit();
      }

      namespace._mediaQuery = window.matchMedia(DESKTOP_QUERY);
      if (namespace._mediaQuery && typeof namespace._mediaQuery.addEventListener === 'function') {
        namespace._mediaQuery.addEventListener('change', namespace._onResize);
      } else {
        window.addEventListener('orientationchange', namespace._onResize, { passive: true });
      }
      document.addEventListener('product:color-swap:done', namespace._onSwap);
      namespace._eventsBound = true;
    } else {
      scheduleInit();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
